// extracted by mini-css-extract-plugin
export default {"Logout":"Logout_Logout__AoOAI","LogoutText":"Logout_LogoutText__Q1i97"};